// Downshift points its menu and input at a label element. Without a visible
// label that element does not exist, so the reference is removed and the
// fallback text, when there is one, names them instead.
export const getDownshiftLabelProps = (
  labelId: string | undefined,
  fallbackName: string | undefined
) => {
  if (labelId) {
    return {};
  }
  return fallbackName
    ? { 'aria-labelledby': undefined, 'aria-label': fallbackName }
    : { 'aria-labelledby': undefined };
};
